import React, { useContext } from 'react';
import styled from 'styled-components';
import { AddStorageDataContext } from 'context/AddStorageContext';
import { STORAGE_ICONS } from 'utils/StorageConstants';
import { A1 } from 'styled_components/Storage/Icons/A1';
const CDN_URL = process.env.REACT_APP_CDN_URL;

const RedundancyIcon = `${CDN_URL}storage/Storage-mirror-arrows-inactive.svg`;
const SmallPublicIcon = `${CDN_URL}common/icon-public-white-default.svg`;
const SmallPrivateIcon = `${CDN_URL}storage/Storage-private-icon-default.svg`;

const SELECTION_COLORS = [
	'#262627',
	'#9ea1a2',
	'#2a7de1',
	'#008388',
	'#a8ad00',
	'#9164cc',
	'#df6a2e',
];
const AddShareHeaderStyle = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	position: relative;
	background-color: transparent;
	.color-selector {
		display: flex;
		position: absolute;
		bottom: 0;
		right: 0;
		.color-block {
			width: 35px;
			height: 25px;
			cursor: pointer;
			margin-right: 8px;
			margin-bottom: 4px;
			border: 2px solid white;
			&.selected {
				border: 0px solid white;
			}
		}
	}
	.title {
		margin-left: 10px;
		text-align: left;
	}
	.top-section-container {
		min-width: 75px;
		height: 75px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: ${props => props.theme.Cool_Gray_Light_3};
		position: relative;
		margin-top: -8px;
		border-radius: 14px;
		.top-left-icon {
			width: 15px;
			height: 15px;
			position: absolute;
			top: 5px;
			left: 5px;
			display: flex;
			justify-content: center;
			align-items: center;
			img {
				width: 15px;
				height: 15px;
			}
		}
		.top-right-icon {
			width: 15px;
			height: 15px;
			position: absolute;
			top: 5px;
			right: 5px;
			display: flex;
			justify-content: center;
			align-items: center;

			img {
				width: 15px;
				height: 15px;
			}
		}
		.center-icon {
			width: 50px;
			height: 50px;
			display: flex;
			justify-content: center;
			align-items: center;
			img {
				width: 30px;
				height: 30px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.color-selector {
			bottom: 10px;
			right: 0;
			.color-block {
				width: 50px;
				height: 40px;
				margin-right: 12px;
				margin-bottom: 5px;
				border: 2px solid white;

				&.selected {
					border: 0px solid white;
				}
			}
		}
		.title {
			margin-top: 15px;
			margin-left: 15px;
		}

		.top-section-container {
			min-width: 120px;
			height: 110px;
			margin-top: -30px;

			.top-left-icon {
				width: 20px;
				height: 20px;
				img {
					width: 20px;
					height: 20px;
				}
			}
			.top-right-icon {
				width: 20px;
				height: 20px;

				img {
					width: 20px;
					height: 20px;
				}
			}
			.center-icon {
				width: 90px;
				height: 80px;

				img {
					width: 50%;
					height: 60%;
				}
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.color-selector {
			bottom: 10px;
			right: 0;
			.color-block {
				width: 80px;
				height: 45px;
				margin-right: 28px;
				margin-bottom: 8px;
				border: 2px solid white;

				&.selected {
					border: 0px solid white;
				}
			}
		}
		.title {
			margin-top: 58px;
			margin-left: 15px;
		}
		.top-section-container {
			width: 200px;
			height: 203px;
			margin-top: -33px;
			.top-left-icon {
				width: 45px;
				height: 40px;
				top: 10px;
				left: 10px;

				img {
					width: 45px;
					height: 40px;
				}
			}
			.top-right-icon {
				width: 45px;
				height: 40px;
				top: 10px;
				right: 10px;
				img {
					width: 45px;
					height: 40px;
				}
			}
			.center-icon {
				width: 165px;
				height: 135px;

				img {
					width: 50%;
					height: 60%;
				}
			}
		}
	}
`;

export const AddShareHeader = ({ title, inputs, index }) => {
	const { change } = useContext(AddStorageDataContext);
	const Icon = STORAGE_ICONS[inputs?.icon] ? STORAGE_ICONS[inputs?.icon] : A1;

	return (
		<AddShareHeaderStyle>
			<div className='top-section-container'>
				<div className='top-left-icon'>
					{inputs?.redundancy && <img src={RedundancyIcon} className='redundancy-icon' />}
				</div>
				<div className='top-right-icon'>
					{inputs?.access === 'public' && (
						<img src={SmallPublicIcon} className='small-accessibility' />
					)}
					{inputs?.access === 'private' && (
						<img src={SmallPrivateIcon} className='small-accessibility' />
					)}
				</div>
				<div className='center-icon'>{<Icon color={inputs?.color} />}</div>
			</div>
			<div className='title body10'>{title}</div>
			{index === 0 && (
				<div className='color-selector'>
					{SELECTION_COLORS.map(color => (
						<div
							className={`color-block ${inputs?.color === color ? 'selected' : ''}`}
							style={{ background: color }}
							onClick={() => change({ target: { name: 'color', value: color } })}
						>
							{''}
						</div>
					))}
				</div>
			)}
		</AddShareHeaderStyle>
	);
};
